const accounts = state => state.accounts;

export default {
    accounts,
};
